<div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Session Calendar</h3></div>
    <full-calendar
      #calendar
      [options]="calendarOptions"
      [events]="Events"
    ></full-calendar> 
</div>